import { Injectable } from "@angular/core";
import { BehaviorSubject, map } from "rxjs";

import { SharedToasterService } from "../../../../shared/services/shared-toaster.service";
import { AssignmentDetailsModel } from "../models/assignment-details.model";
import { AssignmentDetailsService } from "./assignment-details.service";

@Injectable({
    providedIn: 'root'
})

export class AssignmentDetailsStateService {
    public assignmentDetails = new BehaviorSubject<AssignmentDetailsModel | null | undefined>(null);

    constructor(
        private assignmentDetailsService: AssignmentDetailsService,
        private sharedToasterService: SharedToasterService
    ) { }

    public loadAssingmentDetails(assignmentId: number): void {
        this.assignmentDetails.next(null);
        this.assignmentDetailsService.getAssignmentDetails(assignmentId).pipe(map(assignment => {
            return assignment;
        }
        )).subscribe({
            next: assignmentDetails => {
                this.assignmentDetails.next(assignmentDetails);
            },
            error: (error) => {
                this.assignmentDetails.next(undefined);
                this.sharedToasterService.showGeneralDataLoadingError();
            },
        })
    }
}
